import axios from 'axios';

const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

let isLoggingOut = false;

const forceLogout = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  const projectId = window.localStorage.getItem('PROJECT_ID');
  window.localStorage.removeItem('JWT_TOKEN');
  if (projectId) {
    window.location.replace(`/${projectId}/login`);
  }
};

/**
 * Singleton 패턴으로 생성된 axios instance입니다.
 * baseURL과 액세스 토큰을 적용하는 코드가 반영되어 있으며,
 * 액세스 토큰은 XMLHttpRequest 시마다 새로 찾아오기 때문에 시점적으로 유리합니다.
 */
const ApiClient = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_API_SERVER || 'https://worker.api.caas.works/v1',
  };
  const instance = axios.create(defaultOptions);

  instance.interceptors.request.use(async (request) => {
    if (request.headers.Authorization) return request;
    const token = window.localStorage.getItem('JWT_TOKEN');
    if (token) {
      if (isTokenExpired(token)) {
        forceLogout();
        return Promise.reject(new axios.Cancel('Token expired'));
      }
      request.headers!.Authorization = `Bearer ${token}`;
    }
    return request;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        forceLogout();
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

export default ApiClient();
